<template>
  <div>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="名称" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="说明" :label-width="formLabelWidth">
        <el-input v-model="form.intro" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="完成数量" :label-width="formLabelWidth">
          <el-input v-model="form.badge_value" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="未激活图片" :label-width="formLabelWidth">
          <div class="img-item">
              <div class="addimg-select" @click="openUpload('image')" v-if="!form.image"><i class="el-icon-plus"></i></div>
              <el-image class="imgw100" v-else :src="form.image" fit="cover" alt="" :preview-src-list="[form.image]" />
              <a v-if="form.image" href="javascript:void(0);" class="delete-btn" @click.stop="form.image=''"><i class="el-icon-close"></i></a>
          </div>
          <p class="gray9">建议尺寸180x180px，PNG</p>
      </el-form-item>

      <el-form-item label="已激活图片" :label-width="formLabelWidth">
          <div class="img-item">
              <div class="addimg-select" @click="openUpload('act_image')" v-if="!form.act_image"><i class="el-icon-plus"></i></div>
              <el-image class="imgw100" v-else :src="form.act_image" fit="cover" alt="" :preview-src-list="[form.act_image]" />
              <a v-if="form.act_image" href="javascript:void(0);" class="delete-btn" @click.stop="form.act_image=''"><i class="el-icon-close"></i></a>
          </div>
          <p class="gray9">建议尺寸180x180px，PNG</p>
      </el-form-item>

      <el-form-item label="键值" :label-width="formLabelWidth">
          <el-input v-model="form.key_name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="状态" :label-width="formLabelWidth">
          <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addFun" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  <!--上传图片组件-->
  <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import BadgeApi from '@/api/study/badge.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
        Upload,
    },
    data() {
      return {
        form: {
          name: '',
          intro: '',
          badge_value: '',
          image: '',
          act_image: '',
          key_name: '',
          status: 1,
        },
        formRules: {},
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        isupload: false,
        type: '',
      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*添加*/
      addFun() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            BadgeApi.add(params, true).then(data => {
                self.loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

      /*上传*/
      openUpload(e) {
          this.type = e;
          this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
          if (e != null) {
              this.form[this.type] = e[0].file_path;
              this.form[this.type+'_id'] = e[0].file_id;
          }
          this.isupload = false;
      },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/badge/badge/part/Add.vue